import React from 'react'
import Link from 'gatsby-link'

import github from '../img/github-icon.svg'
import logo from '../img/stonecreative-logo.png'

const Navbar = () => (
  <nav className="navbar is-transparent">
    <div className="container">
      <div className="navbar-brand">
        <Link to="/" className="navbar-item">
          <figure className="image">
            <img src={logo} alt="Stone Creative" style={{ width: 40 }} />
          </figure>
        </Link>
      </div>
      <div className="navbar-start">
        <Link className="navbar-item" to="/about">
          About
        </Link>
        {/*<Link className="navbar-item" to="/products">
          Products
        </Link>*/}
      </div>
      <div className="navbar-end">
        <a
          className="navbar-item"
          href="https://github.com/stonecreative/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="icon">
            <img src={github} alt="Github" />
          </span>
        </a>
      </div>
    </div>
  </nav>
)

export default Navbar



// WEBPACK FOOTER //
// ./src/components/Navbar.js